var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4896 8.26407L18.4883 8.26277L10.737 0.512592C10.4066 0.182021 9.96734 0 9.50013 0C9.03287 0 8.5936 0.18191 8.26307 0.512443L0.515809 8.25869C0.513211 8.26129 0.510614 8.26404 0.508016 8.26667C-0.170487 8.94896 -0.1693 10.056 0.511356 10.7366C0.82229 11.0477 1.23302 11.2278 1.67214 11.2467C1.68996 11.2484 1.70796 11.2493 1.72607 11.2493H2.035V16.953C2.035 18.0817 2.9534 19 4.08246 19H7.11497C7.42235 19 7.67167 18.7508 7.67167 18.4434V13.9717C7.67167 13.4566 8.09068 13.0377 8.60577 13.0377H10.3944C10.9096 13.0377 11.3285 13.4567 11.3285 13.9717V18.4434C11.3285 18.7508 11.5777 19 11.8852 19H14.9178C16.0468 19 16.9652 18.0817 16.9652 16.953V11.2493H17.2517C17.7188 11.2493 18.1581 11.0674 18.4887 10.7369C19.1701 10.0552 19.1704 8.94625 18.4896 8.26407Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.1206bec99430790cc636b674ca0985e9.svg";
export { ForwardRef as ReactComponent };